import { Trash2 } from 'lucide-react';
import Modal from './Modal';

interface BulkDeleteModalProps {
  isOpen: boolean;
  count: number;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function BulkDeleteModal({ isOpen, count, deleting, onClose, onConfirm }: BulkDeleteModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Selected Addresses" dismissible={!deleting}>
      <p style={{ marginBottom: '20px' }}>
        Are you sure you want to delete {count} address{count !== 1 ? 'es' : ''}? This action cannot be undone.
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button className="btn btn-ghost" onClick={onClose} disabled={deleting}>
          Cancel
        </button>
        <button
          className={`btn btn-danger ${deleting ? 'loading' : ''}`}
          onClick={onConfirm}
          disabled={deleting || count === 0}
        >
          <Trash2 size={16} />
          {deleting ? 'Deleting...' : `Delete ${count}`}
        </button>
      </div>
    </Modal>
  );
}

export default BulkDeleteModal;
